export const isServer = typeof window === 'undefined';

export function brandFormatter(brand?: string) {
  if (!brand) return '';

  const brandLowerCase = brand.toLowerCase();

  return brandLowerCase.charAt(0).toUpperCase() + brand.slice(1);
}

const RX_WHITE_SPACES = /\s+/gm;

export function sanitizeSpaces(str: string) {
  return str.replace(RX_WHITE_SPACES, ' ');
}

export function replaceSpacesWithUnderscores(str: string) {
  return str.replace(RX_WHITE_SPACES, '_');
}

export function getBrandFromMagazineIssueId(issueId: string) {
  const split = issueId.split('_');

  return split.length === 3 ? split[0] : 'businessweek';
}

export function urlHasQueryParams(url: string): boolean {
  const queryIndex = url.indexOf('?');

  return queryIndex !== -1;
}
